import React from 'react';
import {Link} from 'react-router-dom';
import {Package, ExternalLink} from 'lucide-react';
import {AppCardTitle, AppText} from '../../../../Presentation/components/ui/Typography';

interface StoreDeliveriesLinkCardProps {
  storeId: string;
  storeName: string;
}

/**
 * بطاقة تعرض رابطاً لفتح سجل التسليمات في صفحة مستقلة.
 * تُستخدم داخل تفاصيل المتجر بدلاً من تضمين السجل كاملاً.
 */
export const StoreDeliveriesLinkCard: React.FC<StoreDeliveriesLinkCardProps> = ({
  storeId,
  storeName
}) => (
  <div className="bg-white border border-gray-200 rounded-lg p-4">
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-brand-50">
          <Package className="w-5 h-5 text-brand-600" />
        </div>
        <div>
          <AppCardTitle className="text-gray-900 mb-0.5">سجل التسليمات</AppCardTitle>
          <AppText className="text-sm text-gray-500">
            عرض سجل تسليمات المتجر «{storeName}» في صفحة كاملة مع فلاتر وترقيم.
          </AppText>
        </div>
      </div>
      <Link
        to={`/dashboard/stores/${storeId}/deliveries`}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 transition-colors"
      >
        <ExternalLink className="w-4 h-4" />
        فتح سجل التسليمات
      </Link>
    </div>
  </div>
);
